if (typeof cartStarterUrl === 'undefined') {
    cartStarterUrl = '/cart-starter';
}

if (typeof isAuthenticated === 'undefined') {
    isAuthenticated = false;
}

function getCartStarterItemSessionStorageKey() {
    return 'cartStarterItem';
}

var CART_STARTER = {
    addProductToCartStarter: cartStarterUrl + '/addToCartStarter',
    deleteUrl: cartStarterUrl + '/deleteProduct/',
    deleteAllUrl: cartStarterUrl + '/deleteAllProduct',
    updateUrl: cartStarterUrl + '/updateProduct/',
    showDeleteAllModalUrl: cartStarterUrl + '/showDeleteAllModal',
    deleteAllRemodalSelector: '#deleteCartStarterList',

    bindAddToCartFromCartStarter: function () {
        $('.addToCartFromCartStarterBtn').on('click', function () {
            addCartStarterProductsToCart($(this));
        });
    },

    addSavedProductToCartStarterAfterLogin: function () {
        var cartStarterItemAsJson = sessionStorage.getItem(getCartStarterItemSessionStorageKey());
        if (isAuthenticated && cartStarterItemAsJson) {
            var productCode = parseProduct(cartStarterItemAsJson).getCode();
            var $productTile = $(document).find('.item-addToCart[data-product-code="' + productCode + '"]');
            var $addToCartStarterButton = $productTile.find('.addToCartStarter');
            executeAddProductToCartStarter($addToCartStarterButton.get(0), $productTile);
        }
    }
};

function configureProductTileCartStarterListName($tilesContainer) {
    var productTileCartStarterListName = 'cartStarterAccount';
    $('.product-tile-cart-starter', $tilesContainer).attr('data-list-name', productTileCartStarterListName);
}

function deleteAllProductsFromCartStarter() {
    var container = $(CART_STARTER.deleteAllRemodalSelector);
    TINK.inProgress(container);
    $.ajax({
        type: 'POST',
        url: CART_STARTER.deleteAllUrl,
        contentType: 'application/json',
        success: function () {
            window.location = window.location.pathname;
        },
        error: function (jqXHR) {
            if (!TINK.redirectIfConflict(jqXHR)) {
                $('#deleteAllCartStarterModal .remodal').remodal().close();

                var errorBox = $('#errorBoxCartStarter');
                errorBox.text(window['cartStarterDeleteAllErrorMessage']);
                errorBox.show();
                $('html, body').animate({scrollTop: errorBox.offset().top - 75}, 'fast');
                TINK.stopProgress(container);
            }
        }
    });
}

function executeAddProductToCartStarter(target, $product, completeCallback) {
    var $target = $(target);
    var $errorBox = $product.find('.error-summary');
    hideErrorMessages($product);
    TINK.inProgress($product);

    var cartStarterItem = parseProduct(sessionStorage.getItem(getCartStarterItemSessionStorageKey()));
    $.ajax({
        type: 'POST',
        url: CART_STARTER.addProductToCartStarter,
        contentType: 'application/json; charset=utf-8',
        data: stringifyProduct(cartStarterItem),
        success: function () {
            $target.find('span.favoriteAction').text(window['cartStarterRemoveButtonDescription']);
            $target.addClass('is_favorite is_active');

            if (isInWebview()) {
                sendFavoriteItemUpdateEventToDevice($product);
            }

            var listName = $product.closest("[data-list-name]").attr('data-list-name');
            pushAddProductToCartStarterMetrics($product, cartStarterItem.getCode(), listName != null ? listName : "");

            // Criteo tracking
            if ($product.data('criteo-on-wish-list-beacon')) {
                CriteoProductTracker.sendOnWishListEvent($product.data('criteo-on-wish-list-beacon'));
            }
        },
        error: function (jqXHR) {
            if (!TINK.redirectIfConflict(jqXHR)) {
                $errorBox.find('.product-cart-starter-add-error').removeClass('hide');
                $errorBox.removeClass('hide');
            }
        },
        complete: function () {
            TINK.stopProgress($product);
            sessionStorage.removeItem(getCartStarterItemSessionStorageKey());
            if (completeCallback) {
                completeCallback();
            }
        }
    });
}

function updateProductCartStarter() {
    var productTile = $(this).parents('.item-addToCart');
    TINK.inProgress(productTile);
    hideErrorMessages(productTile);

    var productCode = productTile.data('product-code'),
        qty = productTile.find('.qty-addToCart').first().text(),
        productName = productTile.data('product-name'),
        shopTrackingToken = productTile.data('shop-tracking-token'),
        shopTrackingWebPage = productTile.data('shop-tracking-web-page'),
        selector = productTile.find('.select-addToCart'),
        optionId = $('option:selected', selector).attr('code-id'),
        optionCode = selector.attr('data-configuration-code');
    var product = new Product(productCode, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage);

    $.ajax({
        type: 'POST',
        url: CART_STARTER.updateUrl + productTile.attr('data-cart-starter-entry-number'),
        contentType: 'application/json',
        dataType: 'json',
        data: stringifyProduct(product),
        success: function () {
            updateQtyIncrementerButtonsState();
            productTile.attr('data-qty', qty);
        },
        error: function (jqXHR) {
            if (!TINK.redirectIfConflict(jqXHR)) {
                var errorBox = productTile.find('.error-summary');
                errorBox.find('.product-cart-starter-update-error').removeClass('hide');
                errorBox.removeClass('hide');

                // Reset quantity and cut option
                var oldQty = productTile.attr('data-qty');
                productTile.find('.qty-addToCart').text(oldQty);

                updateQtyIncrementerButtonsState();
            }
        },
        complete: function () {
            TINK.stopProgress(productTile);
        }
    });
}

function addCartStarterProductsToCart($target, $tilesContainer) {
    var productsListToAdd = [];
    var productsTilesList = [];

    if (typeof $tilesContainer === 'undefined') {
        $tilesContainer = $('body');
    }

    var $waitingContainer = $target.parents('.addMultipleProductsContainer').first();
    TINK.inProgress($waitingContainer);

    // Get all selected products to add to cart (not in cart)
    var isProductSelectionError = false;
    $('input[type=checkbox]:checked.addToCartFromCartStarter', $tilesContainer).each(function () {
        var productTile = $(this).closest('.item-addToCart');
        var inCart = productTile.hasClass('item-in-cart');
        if (!inCart.length) {
            var qty = productTile.attr('data-qty'),
                productName = productTile.data('product-name'),
                shopTrackingToken = productTile.data('shop-tracking-token'),
                shopTrackingWebPage = productTile.data('shop-tracking-web-page'),
                selector = productTile.find('.select-addToCart'),
                optionSelected = $('option:selected', selector),
                optionVal = optionSelected.val(),
                optionId = optionSelected.attr('code-id'),
                optionCode = selector.attr('data-configuration-code'),
                ageRestricted = productTile.data('age-restriction'),
                productAlcohol = productTile.data('product-alcohol'),
                productLoto = productTile.data('product-loto');

            if (optionSelected.length && (!optionVal || optionVal == '-1' || optionVal == '1')) {
                productTile.addClass('error');
                hideErrorMessages(productTile);
                productTile.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
                productTile.find('.product-make-choice-cart-starter-error').removeClass('hide');
                isProductSelectionError = true;
            } else if ((ageRestricted && $('.mini-cart-side-panel--spontaneous').attr('data-express-service') === 'true') ||
                (productAlcohol && $('.mini-cart-side-panel--spontaneous').attr('data-alcohol-data-alcohol-delivery-disallowed-by-store') === 'true') ||
                (productAlcohol && $('.mini-cart-side-panel--spontaneous').attr('data-alcohol-data-alcohol-delivery-disallowed-by-timeslot') === 'true') ||
                (productAlcohol && $('.mini-cart-side-panel--spontaneous').attr('data-cart-fsa-alcohol-restricted') === 'true')) {
                productTile.addClass('error');
                hideErrorMessages(productTile);
                productTile.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
                productTile.find('.product-age-restriction-cart-starter-error').removeClass('hide');
                isProductSelectionError = true;
            } else {
                var {$product, listName} = _getListNameAndProductDOMFromCartStarter($tilesContainer, this.value);
                var product = new Product(this.value, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage, productAlcohol, productLoto, listName);

                configureProductTileCartStarterListName($tilesContainer);
                //Forcer à nouveau la qty pour obtenir la bonne valeur au lieu de celle en cache (data)
                $product.data('qty', qty);
                push_add_cart_info_metrics($product, qty, listName);

                productsListToAdd.push(product);
                productsTilesList.push(productTile);

                //add favourites from my cart section mobile
                if ($target.hasClass('btn-fav')) {
                    setTimeout(function () {

                        let favoritesValidationCart = true;
                        // check if product is valid to be added to cart from favourites in cart
                        $('.product-age-restriction-cart-starter-error:not(.hide)', $tilesContainer).each(function () {
                            var productTile = $(this).closest('.item-addToCart');
                           if ( productTile.find('.checkbox--standard.ptcs-checkbox input').is(':checked')){
                               favoritesValidationCart = false
                           }
                        });

                        if (favoritesValidationCart) {
                            location.reload();
                        }
                    }, 300);
                }
            }
        }
    });

    if (!isProductSelectionError) {
        if (productsListToAdd.length < 1) {
            window['displayCartNotification'](0, $waitingContainer, null);
        } else {
            var $errorBox = $('#errorBoxCartStarter');
            if ($errorBox.length < 1) {
                $errorBox = $('#errorBox');
            }

            addSelectedProductsToCart(productsListToAdd, productsTilesList, null, null, $target, undefined, $errorBox, true, null);
            TINK.stopProgress($waitingContainer);
        }
    } else {
        TINK.stopProgress($waitingContainer);
    }
}

function _getListNameAndProductDOMFromCartStarter($tilesContainer, productCode) {
    var $product = $('.product-tile-cart-starter[data-product-code="' + productCode + '"]', $tilesContainer);
    var listName = $product.data('list-name');
    return {$product, listName};
}

function callbackSuccessDeleteProductFromCartStarter(target, $product) {
    $(target).removeClass('is_favorite');
    $(target).addClass('is_active');
    if (isInWebview()) {
        sendFavoriteItemUpdateEventToDevice($product);
    } else {
        TINK.updateStatusNotification(window['cartStarterDeleteConfirmationMessage']);
    }
}

function displayNotificationForLogin(target) {
    if (!TINK.matchMediaMobile()) {
        var $target = $('html,body');
        $target.animate({scrollTop: $target.offset().top}, 300);
    }

    if (target !== undefined) {
        $(target).addClass('is_active').remodal().open();
    }
}

function displayDeleteAllModal(target) {
    var isModalLoaded = $(CART_STARTER.deleteAllRemodalSelector).length;
    if (!isModalLoaded) {
        $.ajax({
            type: "GET",
            url: CART_STARTER.showDeleteAllModalUrl,
            contentType: 'application/json',
            success: function (responseData) {
                $('.remodal-delete-all-cart-starter').append(responseData);
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            }
        });
    }
}

function getCheckedProductCodesSessionStorageKey() {
    return 'cart-starter-checked-product-codes';
}

$(function () {
    CART_STARTER.bindAddToCartFromCartStarter();
    CART_STARTER.addSavedProductToCartStarterAfterLogin();

    window['addProductToCartStarter'] = function (target) {
        var product = $(target).closest('.item-addToCart'),
            qty = +(product.find('.qty-addToCart').first().text()),
            selector = product.find('.select-addToCart'),
            sku = product.data('product-code'),
            optionId = $('option:selected', selector).attr('code-id'),
            optionCode = selector.attr('data-configuration-code'),
            productName = product.data('product-name'),
            shopTrackingToken = product.data('shop-tracking-token'),
            shopTrackingWebPage = product.data('shop-tracking-web-page');

        if (qty < 1) {
            qty = 1;
        }

        $('.item-addToCart').each(function () {
            var curSelect = $(this).find('.select-addToCart');
            if (curSelect && curSelect.hasClass('error')) {
                curSelect.removeClass('error');
                $(this).find('.error-summary').addClass('hide');
                $(this).find('.product-make-choice-cart-starter-error').addClass('hide');
            }
        });

        //select first option for Express Delivery if no value selected
        if (selector && selector.find('option:selected').val() == '1' && $('.mini-cart-side-panel--spontaneous').attr('data-express-service') === 'true') {
            if (selector.find('option').length > 1) {
                selector.find('option:eq(1)').prop('selected', true);
                optionId = $('option:selected', selector).attr('code-id');
            }
        }
        //add error if no value selected
        if (selector && selector.find('option:selected').val() == '1') {
            selector.addClass('error');
            hideErrorMessages(product);
            product.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
            product.find('.product-make-choice-cart-starter-error').removeClass('hide');
            return;
        }

        var cartStarterItem = new Product(sku, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage);
        sessionStorage.setItem(getCartStarterItemSessionStorageKey(), cartStarterItem.stringify());

        if (!isAuthenticated) {
            displayNotificationForLogin(target);
        } else {
            executeAddProductToCartStarter(target, product);
        }
    };

    window['deleteProductFromCartStarter'] = function (target, callbackSuccess) {
        var productContainer = $(target).parents(".item-addToCart");
        var productCode = productContainer.attr("data-product-code");
        var errorBox = productContainer.find(".error-summary");
        hideErrorMessages(productContainer);

        TINK.inProgress(productContainer);
        $.ajax({
            type: "POST",
            url: CART_STARTER.deleteUrl + productCode,
            contentType: 'application/json',
            success: function () {
                if (callbackSuccess) {
                    callbackSuccess();
                }
                TINK.stopProgress(productContainer);
                $(target).find('span.favoriteAction').text(window['cartStarterAddButtonDescription']);

                //IF IN MY CART PAGE UPDATE QUANTITY BUTTONS
                document.getElementById('favorites-from-cart-container') && updateQtyButton($('#favorites-from-cart-container'));
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    errorBox.find('.product-cart-starter-delete-error').removeClass('hide');
                    errorBox.removeClass('hide');
                    errorBox.attr('tabindex', '0');
                    errorBox.focus();
                    TINK.stopProgress(productContainer);
                }
            }
        });
    };

    window['findFlowCartStarter'] = function (target) {
        if (isInWebview() && !isAuthenticated) {
            sendUserNotAuthenticatedEventToDevice();
            return;
        }

        if (!isAuthenticated) {
            loginSidePanel('favourite');
        }

        if (target.closest('.pdpVisuals')) {
            target = document.querySelector('.pdp--pt-actions .action__favorite');
        }

        if (target) {
            var isInCartStarter = $(target).hasClass('is_favorite');
            if (!isInCartStarter) {
                addProductToCartStarter(target)
            } else {
                deleteProductFromCartStarter(target, function () {
                    var $product = $(target).closest('.item-addToCart');
                    callbackSuccessDeleteProductFromCartStarter(target, $product);
                });
            }
        }
    };

    window['updateCheckboxesStatusWithSavedCheckedProducts'] = function () {
        function loadCheckedProducts() {
            var checkedProductCodesAsString = sessionStorage.getItem(getCheckedProductCodesSessionStorageKey());
            return checkedProductCodesAsString ? JSON.parse(checkedProductCodesAsString) : [];
        }

        function updateCheckboxStatus(checkedProductCodes, $product) {
            var productCode = $product.data('product-code');
            var productHasBeenSavedAsChecked = checkedProductCodes.indexOf(productCode) > -1;
            $product.find('input[type=checkbox].addToCartFromCartStarter').prop('checked', productHasBeenSavedAsChecked);
        }

        var $allProducts = $(document).find('.product-tile-cart-starter');

        var hasProductCodesInStorage = sessionStorage.hasOwnProperty(getCheckedProductCodesSessionStorageKey());
        if (!hasProductCodesInStorage) {
            $allProducts.each(function (index, product) {
                $(product).find('input[type=checkbox].addToCartFromCartStarter').prop('checked', true);
            });
        } else {
            var checkedProductCodes = loadCheckedProducts();
            if (checkedProductCodes.length > 0) {
                $allProducts.each(function (index, element) {
                    updateCheckboxStatus(checkedProductCodes, $(element));
                });
            }
        }
    };

    window['saveCheckedProducts'] = function () {
        var $checkedProducts = $(document).find('input[type=checkbox].addToCartFromCartStarter:checked').parents('.product-tile-cart-starter');
        var checkedProductCodes = $checkedProducts.map(function (index, element) {
            return $(element).data('product-code');
        }).toArray();
        sessionStorage.setItem(getCheckedProductCodesSessionStorageKey(), JSON.stringify(checkedProductCodes));
    };
});
